// /ieds-back/userExhibitionCentre
import request from "@/utils/request/index";
import { dataCollect } from "./me";

export enum Api {
  CREATE_HALL = "/userExhibitionCentre",
  FETCH_HALL = "/userExhibitionCentre/page",
  FETCH_COMPILE = "/editResearchTemplate/queryPage",
  BIND_COMPILE = "/userExhibitionCentre/useEditTemplate",
  FETCH_HALL_DETAILS = "/userExhibitionCentre",
  FETCH_COMPILE_MENU = "/editResearchMenu/getTreeAll",
  FETCH_COMPILE_RESOURCE = "/editResearchMenuResource/list",
  ADD_COMPILE_RESOURCE = "/editResearchMenuResource/save",
  DEL_COMPILE_RESOURCE = "/editResearchMenuResource/delete",
  FETCH_EXBITION_HALL = "/userExhibitionItems/centreNotAssociatedItems",
  FETCH_BIND_EXBITION_HALL = "/userExhibitionItems/getByCentreId",
  BIND_EXBITION = "/userExhibitionCentre/centreBindingItems",
  RENAME_COMPILE = "/editResearchMenu/updateNameById",
  ADD_COMPILE_NODE = "/editResearchMenu/saveOrUpdate",
  DELETE_COMPILE_NODE = "/editResearchMenu/delete",
  FETCH_HISTORY_HALL = "/userExhibitionCentre/recentUseQueryPage",
  DELETE_HALL = "/userExhibitionCentre",
  CLONE_HALL = "/userExhibitionCentre/clone",
  RENAME_HALL = "/userExhibitionCentre/rename",
  UNBIND_EXBITION = "/userExhibitionCentre/centreUnbindItems",
}

// 创建展馆
export const createHall = (data?: any, config?: axiosConfig) => {
  if (!data.id) {
    dataCollect({
      fieldType: [9],
    });
  }
  return request.post(Api.CREATE_HALL, data, config);
};

// 查询展馆
export const fetchHall = (data?: any, config?: axiosConfig) =>
  request.get(Api.FETCH_HALL, data, config);
// 查询展馆详情
export const fetchHallDetails = (data?: any, config?: axiosConfig) =>
  request.get(Api.FETCH_HALL_DETAILS + "/" + data, "", config);

// 编研模板查询
export const fetchCompile = (data?: any) =>
  request.post(Api.FETCH_COMPILE, data);

// 展馆绑定模板
export const bindCompileToHall = (data?: any) =>
  request.post(Api.BIND_COMPILE, data);
// 展馆解绑展项
export const unbindExbition = (data?: any, config?: axiosConfig) =>
  request.post(Api.UNBIND_EXBITION, data, config);
// 编研模板菜单查询
export const fetchCompileMenu = (data?: any) =>
  request.post(Api.FETCH_COMPILE_MENU, data);
// 编研内容
export const fetchCompileResource = (data?: any, config?: axiosConfig) =>
  request.post(Api.FETCH_COMPILE_RESOURCE, data, config);
// 新增编研内容
export const AddCompileResource = (data?: any, config?: axiosConfig) =>
  request.post(Api.ADD_COMPILE_RESOURCE, data, config);
// 删除编研内容
export const delCompileResource = (data?: any, config?: axiosConfig) =>
  request.post(Api.DEL_COMPILE_RESOURCE, data, config);

// 下载编研资料
export const downloadResource = (url: string, config?: axiosConfig) =>
  request.download(url);

// 查询可以绑定的展项列表
export const fetchExbitionToBind = (data?: any, config?: axiosConfig) =>
  request.post(Api.FETCH_EXBITION_HALL, data, config);
// 查询已绑定绑定的展项列表
export const fetchBindExbition = (data?: any, config?: axiosConfig) =>
  request.post(Api.FETCH_BIND_EXBITION_HALL, data, config);

// 展馆绑定展项
export const bindExbitonToHall = (data?: any, config?: axiosConfig) =>
  request.post(Api.BIND_EXBITION, data, config);
// 修改编研名称
export const renameCompile = (data?: any, config?: axiosConfig) =>
  request.post(Api.RENAME_COMPILE, data, config);
// 编研菜单添加子级
export const addCompileTreeNode = (data?: any, config?: axiosConfig) =>
  request.post(Api.ADD_COMPILE_NODE, data, config);
// 删除
export const delCompileTreeNode = (data?: any, config?: axiosConfig) =>
  request.post(Api.DELETE_COMPILE_NODE, data, config);
export const fetchHallHistroy = (data?: any, config?: axiosConfig) =>
  request.get(Api.FETCH_HISTORY_HALL, data, config);
// 删除展馆
export const deleteHall = (data?: any, config?: axiosConfig) =>
  request.delete(Api.DELETE_HALL + "/" + data, {}, config);

// 克隆
export const cloneHall = (data?: any, config?: axiosConfig) =>
  request.post(Api.CLONE_HALL + "/" + data, data, config);
// 展馆重命名
export const renameHall = (data?: any, config?: axiosConfig) =>
  request.post(Api.RENAME_HALL, data, config);
